import { PromotionCondition } from './PromotionCondition'
import withPromotionCondition from './withPromotionCondition'

const ConnectedPromotionCondition = withPromotionCondition(PromotionCondition)

export { ConnectedPromotionCondition as PromotionCondition }
